import { Injectable } from '@angular/core';
// import * as cryptoJS from 'crypto-js';


const USER = 'login_user';
const VENDOR_MODULES = 'vendor_modules';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {}


//   Hash 256 Encryption function
//    sha256(input: string): string {
//     const hash = cryptoJS.SHA256(input);
//     return hash.toString(cryptoJS.enc.Hex);
//   }


  clean(): void {
    window.sessionStorage.clear();
    // Optional: Also clear vendor modules from localStorage
    localStorage.removeItem(VENDOR_MODULES);
  }

  public saveUser(user: any): void {
    window.sessionStorage.removeItem(USER);
    window.sessionStorage.setItem(USER, JSON.stringify(user));
    window.sessionStorage.setItem('user_details', JSON.stringify(user));
    localStorage.setItem('user_details', JSON.stringify(user));
  }

    // ✅ ADD THESE METHODS FOR VENDOR MODULES
  public setVendorModules(modules: any): void {
    window.sessionStorage.removeItem(VENDOR_MODULES);
    window.sessionStorage.setItem(VENDOR_MODULES, JSON.stringify(modules));
    // Optional: Also store in localStorage for persistence
    localStorage.setItem(VENDOR_MODULES, JSON.stringify(modules));
  }


  public getUser(): any {
    const user = window.sessionStorage.getItem(USER);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public isLoggedIn(): boolean {
    const user = window.sessionStorage.getItem(USER);
    if (user) {
      return true;
    }
    return false;
  }


  
}